<template>
	<page>
		<module title="预览店铺">
			<c-detail column="3">
			    <c-detail-item label="店铺名称" colspan="3">
			        {{detailData.shop_name}}
			    </c-detail-item>
				<!-- <c-detail-item label="PC端店铺" colspan="3">
				    {{detailData.shop_pc_url}}
				</c-detail-item> -->
				<c-detail-item label="手机端店铺" colspan="3">
				    <c-file :src="detailData.shop_mini_img_url" style="width:150px;height:150px;" media></c-file>
				</c-detail-item>
			</c-detail>
		</module>
	</page>
</template>

<script>
	export default {
		props: {
			
		},
		
		data() {
			return {
				detailData:{}
			}
		},
		
		computed: {
			
		},
		
		watch: {
			
		},
		
		mounted() {
			this.getShopDetail();
		},
		
		methods: {
			getShopDetail() {
				this.request({
					url: '/stationed/shop/view',
					data: {
						
					},
					loading: true,
					success: data => {
						this.detailData = data;
					}
				});
			},
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>